import './content.css';
export default {
  "content": "pf-v6-c-content",
  "contentA": "pf-v6-c-content--a",
  "contentBlockquote": "pf-v6-c-content--blockquote",
  "contentDd": "pf-v6-c-content--dd",
  "contentDl": "pf-v6-c-content--dl",
  "contentDt": "pf-v6-c-content--dt",
  "contentH1": "pf-v6-c-content--h1",
  "contentH2": "pf-v6-c-content--h2",
  "contentH3": "pf-v6-c-content--h3",
  "contentH4": "pf-v6-c-content--h4",
  "contentH5": "pf-v6-c-content--h5",
  "contentH6": "pf-v6-c-content--h6",
  "contentHr": "pf-v6-c-content--hr",
  "contentLi": "pf-v6-c-content--li",
  "contentOl": "pf-v6-c-content--ol",
  "contentP": "pf-v6-c-content--p",
  "contentPre": "pf-v6-c-content--pre",
  "contentSmall": "pf-v6-c-content--small",
  "contentTable": "pf-v6-c-content--table",
  "contentUl": "pf-v6-c-content--ul",
  "modifiers": {
    "editorial": "pf-m-editorial",
    "visited": "pf-m-visited",
    "pageTitle": "pf-m-page-title",
    "plain": "pf-m-plain"
  }
};